import script from "./AIChatView.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChatView.vue?vue&type=script&setup=true&lang=js"

import "./AIChatView.vue?vue&type=style&index=0&id=aeca6602&lang=css"

const __exports__ = script;

export default __exports__